import { useTranslation } from "react-i18next";

import { asUserRobotStatus } from "../model/types";

/**
 * Figma: `StatusChip/Robot` (11:119). В макете четыре варианта —
 * Running / Paused / Stopped / Error, но бэкенд знает только `active` и
 * `stopped`, поэтому в коде их два (DESIGN.md §8).
 */
export function StatusChip({ status }: { status: string }) {
  const { t } = useTranslation();
  const value = asUserRobotStatus(status);
  const running = value === "active";

  return (
    <span
      className={[
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-micro font-semibold uppercase",
        running ? "bg-surface-profit text-status-profit" : "bg-surface-muted text-text-secondary",
      ].join(" ")}
    >
      <span
        className={`size-[6px] rounded-full ${running ? "bg-status-profit" : "bg-text-tertiary"}`}
        aria-hidden="true"
      />
      {t(`myRobots.status.${value}`)}
    </span>
  );
}
